<section>
    <app-client-filter (filterEmmiter)="setFilter($event)"></app-client-filter>
    <app-client-list [filter]="filter"></app-client-list>
  </section>